import styled from 'styled-components'

import colors from './colors'

// mobile layout
const FeatureImage = styled.img`
  width: 100%;
  min-height: 100px;
  background: ${colors.lightGray};
  margin: 0 0 1rem;
`
const ColumnWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2rem;
  margin: 0 0 3rem;

  @media (max-width: 500px) {    
    grid-template-columns: auto;
  }

  h3 {
    margin: 0 0 .5rem;
    font-size: 1rem;
  }
`

export {
  FeatureImage,
  ColumnWrapper,
}



// WEBPACK FOOTER //
// ./src/styles/onboarding.js